import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';

import { DateFormatter } from '../../Common/dateFormat';
import PriceFormatter from '../../Common/priceFormatter';
import PaymentCellFormatter from './paymentCellFormatter';
import FinalBalanceCellFormatter from './finalBalanceCellFormatter';

class ARModifiableTable extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      sortColumn: null,
      sortDirection: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      const { rows } = nextProps;
      this.setState({ rows });
    }
  }

  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  // Grid does not properly re-render when more than one row is updated at a time
  // Problem solved, for more info Refer to link:
  // https://github.com/adazzle/react-data-grid/issues/332
  rowGetter = (i) => JSON.parse(JSON.stringify(this.getRows()[i]));

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState({
      rows: this.getRows(),
      sortColumn,
      sortDirection,
     });
  }

  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    const rows = this.state.rows.slice();

    for (let i = fromRow; i <= toRow; i++) {
      const rowToUpdate = rows[i];
      const updatedRow = { ...rowToUpdate, ...updated };
      rows[i] = updatedRow;
    }
    if (this.state.rows !== rows) {
      this.setState({ rows });
      this.props.handlePaymentCellChange(rows);
    }
  }

  render() {
    const columns = [
      {
          key: 'InvoiceNum',
          name: <Translate value="invoice_no" />,
          resizable: true,
          filterable: true
      },
      {
          key: 'PostingDate',
          name: <Translate value="invoice_date" />,
          resizable: true,
          filterable: true,
          formatter: DateFormatter
      },
      {
          key: 'BillDueDate',
          name: <Translate value="due_date" />,
          resizable: true,
          filterable: true,
          formatter: DateFormatter
      },
      {
          key: 'FinalPrice',
          name: <Translate value="invoice_amount" />,
          resizable: true,
          filterable: true,
          formatter: PriceFormatter,
      },
      {
          key: 'PreviousBalance',
          name: <Translate value="invoice_balance" />,
          resizable: true,
          filterable: true,
          formatter: PriceFormatter,
      },
      {
          key: 'Amount',
          name: <Translate value="payment" />,
          resizable: true,
          filterable: true,
          editable: this.props.editable,
          formatter:
            <PaymentCellFormatter>
              <PriceFormatter />
            </PaymentCellFormatter>,
      },
      // {
      //     key: 'DiscountedAmount',
      //     name: <Translate value="discount" />,
      //     resizable: true,
      //     filterable: true,
      //     formatter: PriceFormatter,
      // },
      {
          key: 'UnpaidAmount',
          name: <Translate value="remaining_balance" />,
          resizable: true,
          filterable: true,
          formatter:
            <FinalBalanceCellFormatter>
              <PriceFormatter />
            </FinalBalanceCellFormatter>,
          getRowMetaData: (row) => row,
      },
    ];

    return (
        <div style={{ maxWidth: '100%' }} id="ARModifiableTable-dataGrid1">
            <ReactDataGrid
                enableCellSelect
                onGridSort={this.handleGridSort}
                columns={columns}
                rowHeight={25}
                minHeight={350}
                rowGetter={this.rowGetter}
                rowsCount={this.getSize()}
                onGridRowsUpdated={this.handleGridRowsUpdated}
            />
        </div>
    );
  }
}

export default ARModifiableTable;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/EditAR/arModifiableTable.jsx